import React, { useContext, useEffect, useRef, useState } from "react";
import ToggleButtonGroup from "../components/misc/ToggleButtonGroup";
import StyledButtonEmptyWithArrow from "../components/buttons/StyledButtonEmptyWithArrow";
import TextInputArea from "../components/misc/TextInputArea";
import GradientButton from "../components/buttons/GradientButton";
import EmailSize from "../components/misc/EmailSize";
import Lottie from "react-lottie";
import LottieLoader from "../components/misc/sasZb5q9fs.json";
import TextInputArea2 from "../components/misc/TextInputArea2";
import TitleResult from "../components/misc/TitleResult";
import { LanguageContext } from "../context/LanguageContext";
import { getFunctions, httpsCallable } from "firebase/functions";
import { auth, db } from "../firebase";
import {
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import language from "../api/language";
import { usePremiumStatus } from "../hooks/usePremiumStatus";
import { useAuth } from "../context/AuthContext";
import { useMediaQuery } from "react-responsive";

const GenerateContent = () => {
  const { translate } = useContext(LanguageContext);
  const [mailStyle, setMailStyle] = useState("professional");
  const [mailTone, setMailTone] = useState("formal");
  const { currentUser } = useAuth();
  const [countWord, setCountWord] = useState(25);
  const [mailExplanation, setMailExplanation] = useState("");
  const [limitReached, setLimitReached] = useState(false);
  const [mailLanguage, setMailLanguage] = useState("English");
  const [generatedContent, setGeneratedContent] = useState("");
  const [generatedTitle, setGeneratedTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [archiveButtonText, setArchiveButtonText] = useState(
    translate("addToArchive")
  );
  const [emailCount, setEmailCount] = useState(0);
  const [isPremium] = usePremiumStatus();
  const { state } = useLocation();
  const archiveData = state?.archiveData;
  const navigate = useNavigate();
  const [showResults, setShowResults] = useState(false); // New state to toggle visibility
  const [premiumNoticeBlink, setPremiumNoticeBlink] = useState(false);
  const premiumBlinkTimeoutRef = useRef(null);
  const premiumBlinkRestartRef = useRef(null);
  const isCompactActionLayout = useMediaQuery({ query: "(max-width: 1400px)" });

  const handleSelectionChange = (selectedValue) => {
    setMailStyle(selectedValue);
    console.log(selectedValue);
  };

  const handleLanguageChange = (selectedLanguage) => {
    setMailLanguage(selectedLanguage);
  };

  const handleClick2 = () => {
    navigate("/pricing");
  };

  const triggerPremiumNotice = () => {
    if (premiumBlinkRestartRef.current) {
      clearTimeout(premiumBlinkRestartRef.current);
      premiumBlinkRestartRef.current = null;
    }
    if (premiumBlinkTimeoutRef.current) {
      clearTimeout(premiumBlinkTimeoutRef.current);
      premiumBlinkTimeoutRef.current = null;
    }
    setPremiumNoticeBlink(false);

    premiumBlinkRestartRef.current = setTimeout(() => {
      setPremiumNoticeBlink(true);
      premiumBlinkTimeoutRef.current = setTimeout(() => {
        setPremiumNoticeBlink(false);
        premiumBlinkTimeoutRef.current = null;
      }, 500);
    }, 0);
  };

  const handlePremiumRestrictedAction = () => {
    triggerPremiumNotice();
  };

  const premiumAvailabilityLabel = translate("availableOnPremiumPlan");
  const premiumAvailabilityParts = premiumAvailabilityLabel.split("Premium");

  const renderPremiumAvailabilityMessage = () => {
    if (premiumAvailabilityParts.length > 1) {
      return (
        <>
          {premiumAvailabilityParts[0]}
          <span
            className="premium-notice__accent"
            onClick={(event) => {
              event.stopPropagation();
              handleClick2();
            }}
          >
            Premium
          </span>
          {premiumAvailabilityParts.slice(1).join("Premium")}
        </>
      );
    }

    return (
      <span
        className="premium-notice__accent"
        onClick={(event) => {
          event.stopPropagation();
          handleClick2();
        }}
      >
        {premiumAvailabilityLabel}
      </span>
    );
  };

  useEffect(() => {
    if (currentUser) {
      const userStatRef = doc(db, "userStats", currentUser.uid);
      getDoc(userStatRef).then((docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          const lastReset = data.lastReset.toDate();
          const now = new Date();
          if (
            lastReset.getMonth() === now.getMonth() &&
            lastReset.getFullYear() === now.getFullYear()
          ) {
            setEmailCount(data.emailCount);
            setLimitReached(data.emailCount >= 10);
          } else {
            setDoc(
              userStatRef,
              { emailCount: 0, lastReset: serverTimestamp() },
              { merge: true }
            );
            setEmailCount(0);
            setLimitReached(false);
          }
        } else {
          setDoc(userStatRef, { emailCount: 0, lastReset: serverTimestamp() });
          setEmailCount(0);
          setLimitReached(false);
        }
      });
    }
  }, [currentUser]);

  useEffect(() => {
    if (archiveData) {
      setMailStyle(archiveData.mailStyle);
      setMailTone(archiveData.mailTone);
      setCountWord(archiveData.countWord);
      setMailExplanation(archiveData.mailExplanation);
      setMailLanguage(archiveData.mailLanguage);
      setGeneratedContent(archiveData.content);
      setGeneratedTitle(archiveData.title);
    }
  }, [archiveData]);

  const getLanguageCodeFromName = (languageName) => {
    const languageObj = language.find(
      (option) => option.textDropDownEn === languageName
    );
    return languageObj ? languageObj.code : "";
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: LottieLoader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    setArchiveButtonText(translate("addToArchive"));
  }, [translate]);

  useEffect(() => {
    return () => {
      if (premiumBlinkTimeoutRef.current) {
        clearTimeout(premiumBlinkTimeoutRef.current);
      }
      if (premiumBlinkRestartRef.current) {
        clearTimeout(premiumBlinkRestartRef.current);
      }
    };
  }, []);

  const handleSelectionChangeTone = (selectedValue) => {
    setMailTone(selectedValue);
    console.log(selectedValue);
  };

  const addEmailToArchive = async () => {
    setIsLoading2(true);
    const user = auth.currentUser;

    if (!user) {
      console.error("User not authenticated");
      setIsLoading2(false);
      return;
    }

    const emailArchiveRef = doc(db, "archives", user.uid);
    const emailArchive = {
      timestamp: serverTimestamp(),
      title: generatedTitle,
      content: generatedContent,
      mailLanguage,
      mailTone,
      mailStyle,
      countWord,
      mailExplanation,
    };

    try {
      await setDoc(
        emailArchiveRef,
        { [new Date().getTime()]: emailArchive },
        { merge: true }
      );
      setArchiveButtonText(translate("addedToArchive"));
    } catch (error) {
      console.error("Failed to add email to archive:", error);
    }

    setIsLoading2(false);
  };

  const handleClick = () => {
    if (!isPremium && limitReached) {
      alert("You have reached the limit of email generations for this month.");
      return;
    }

    setIsLoading(true);

    // Assurez-vous d'avoir le UID de l'utilisateur actuel pour accéder à son document spécifique
    const userStatRef = doc(db, "userStats", currentUser.uid);

    // Vérification et mise à jour du compteur
    getDoc(userStatRef)
      .then((docSnap) => {
        const data = docSnap.data();
        if (!isPremium && data.emailCount >= 10) {
          setLimitReached(true);
          setIsLoading(false);
          alert("You have reached your email generation limit for this month.");
          return;
        }

        // Appels de fonction pour générer le contenu de l'email
        const functions = getFunctions();
        const generateEmailContentFunc = httpsCallable(
          functions,
          "generateEmailContent"
        );
        const generateEmailTitleFunc = httpsCallable(
          functions,
          "generateEmailTitle"
        );

        Promise.all([
          generateEmailContentFunc({
            mailStyle,
            mailTone,
            countWord,
            mailExplanation,
            mailLanguage,
          }),
          generateEmailTitleFunc({
            mailStyle,
            mailTone,
            countWord,
            mailExplanation,
            mailLanguage,
          }),
        ])
          .then(([contentResult, titleResult]) => {
            setGeneratedContent(contentResult.data.result);
            setGeneratedTitle(titleResult.data.result);

            // Incrément du compteur seulement après la génération réussie
            const newEmailCount = data.emailCount + 1;
            updateDoc(userStatRef, {
              emailCount: newEmailCount,
              lastReset: serverTimestamp(), // optionnellement mettre à jour la date du dernier reset si besoin
            }).then(() => {
              setEmailCount(newEmailCount);
              if (newEmailCount >= 10) {
                setLimitReached(true);
              }
              setIsLoading(false);
              setArchiveButtonText(translate("addToArchive"));
              setShowResults(true); // Show results and hide input controls
            });
          })
          .catch((error) => {
            console.error("Failed to generate content:", error);
            setIsLoading(false);
            setArchiveButtonText(translate("addToArchive"));
          });
      })
      .catch((error) => {
        console.error("Error accessing the user stats document:", error);
        setIsLoading(false);
      });
  };

  const handleChangeView = () => {
    setShowResults(!showResults); // Toggle view between input and results
  };

  const buttonOptions = {
    label: "What style?",
    options: [
      { label: translate("professional"), value: "professional" },
      { label: translate("friendly"), value: "friendly" },
      { label: translate("creative"), value: "creative" },
      { label: translate("promotional"), value: "promotional" },
      { label: translate("informative"), value: "informative" },
    ],
  };

  const toneOptions = {
    label: "What style?",
    options: [
      { label: translate("formal"), value: "formal" },
      { label: translate("humourous"), value: "humourous" },
      { label: translate("casual"), value: "casual" },
      { label: translate("persuasive"), value: "persuasive" },
      { label: translate("inspirational"), value: "inspirational" },
    ],
  };

  const openInGmail = () => {
    const subject = encodeURIComponent(generatedTitle);
    const body = encodeURIComponent(generatedContent);
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&su=${subject}&body=${body}`;

    window.open(gmailUrl, "_blank");
  };

  return (
    <div className="generate-content-bis">
      <div
        className="main-title-homepage"
        style={{
          fontSize: "40px",
          paddingLeft: "0px",
          paddingTop: "20px",
        }}
      >
        {translate("generateEmail")}
      </div>
      {!showResults ? (
        // Input controls
        <div>
          {limitReached && !isPremium && (
            <div
              style={{
                color: "red",
                marginTop: "20px",
                fontSize: "18px",
                paddingLeft: "0px",
              }}
            >
              {translate("emailGenerationLimitReached")}
              <br />
              {translate("remainingEmailsThisMonth")} {10 - emailCount}
            </div>
          )}
          {!limitReached && (
            <div
              style={{
                marginTop: "20px",
                fontSize: "16px",
                paddingLeft: "0px",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              {translate("remainingEmailsThisMonth")} {10 - emailCount}
            </div>
          )}
          <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
            <div style={{ width: "50%" }}>
              <div
                style={{
                  paddingLeft: "00px",
                  paddingTop: "20px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "start",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  className="label-button-group"
                  style={{
                    marginRight: "20px",
                  }}
                >
                  {translate("whatLanguage")}{" "}
                </div>
                <div style={{ paddingBottom: "5px" }}>
                  <StyledButtonEmptyWithArrow
                    onSelectLanguage={handleLanguageChange}
                    selectedLanguageCode={getLanguageCodeFromName(mailLanguage)}
                  />
                </div>
              </div>

              <div
                style={{
                  paddingLeft: "00px",
                  paddingTop: "10px",
                  width: "830px",
                }}
              >
                <ToggleButtonGroup
                  label={translate("whatStyle")}
                  options={buttonOptions.options}
                  onSelectionChange={handleSelectionChange}
                  selectedValue={mailStyle}
                />
              </div>

              <div
                style={{
                  paddingLeft: "0px",
                  paddingTop: "5px",
                  width: "830px",
                }}
              >
                <ToggleButtonGroup
                  label={translate("whatTone")}
                  options={toneOptions.options}
                  onSelectionChange={handleSelectionChangeTone}
                  selectedValue={mailTone}
                />
              </div>

              <div
                style={{
                  paddingLeft: "0px",
                  paddingTop: "20px",
                }}
              >
                <TextInputArea
                  value={mailExplanation}
                  onChangeText={setMailExplanation}
                  label={translate("explainContent")}
                />
              </div>

              <div
                style={{
                  marginLeft: "0px",
                  paddingTop: "10px",
                  display: "flex",
                  flexDirection: "row",
                  width: "800px",
                  justifyContent: "space-between",
                }}
              >
                <EmailSize countWord={countWord} setCountWord={setCountWord} />
                <div
                  style={{
                    width: "250px",
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  {isLoading ? (
                    <Lottie options={defaultOptions} height={30} width={100} />
                  ) : (
                    <GradientButton
                      text={translate("generateEmail")}
                      onClick={handleClick}
                      disabled={limitReached && !isPremium}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Results display
        <div
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {!isLoading && (
            <div style={{ width: "80%", paddingTop: "20px" }}>
              <TitleResult
                label={translate("subject")}
                content={generatedTitle}
              />
              <br />
              <TextInputArea2
                label={translate("textBody")}
                content={generatedContent}
              />
              <br />
              <div
                style={{
                  width: "95%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {isLoading2 ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "12px",
                    }}
                  >
                    <Lottie options={defaultOptions} height={30} width={100} />
                    <GradientButton
                      text={translate("sendInGmail")}
                      onClick={openInGmail}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: isCompactActionLayout ? "column" : "row",
                      width: "100%",
                      gap: "20px",
                      alignItems: isCompactActionLayout
                        ? "stretch"
                        : "flex-start",
                      justifyContent: isCompactActionLayout
                        ? "center"
                        : "space-between",
                      flexWrap: isCompactActionLayout ? "nowrap" : "wrap",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                        minWidth: isCompactActionLayout ? "100%" : "250px",
                        gap: "8px",
                      }}
                    >
                      {!isPremium ? (
                        <GradientButton
                          text={archiveButtonText}
                          onClick={handlePremiumRestrictedAction}
                        />
                      ) : (
                        <GradientButton
                          text={archiveButtonText}
                          onClick={addEmailToArchive}
                          disabled={
                            archiveButtonText === translate("addedToArchive")
                          }
                        />
                      )}

                      {!isPremium && (
                        <div
                          className={`${
                            premiumNoticeBlink
                              ? "premium-notice premium-notice--blink"
                              : "premium-notice"
                          }`}
                          onClick={handleClick2}
                        >
                          {renderPremiumAvailabilityMessage()}
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                        minWidth: isCompactActionLayout ? "100%" : "250px",
                        gap: "8px",
                      }}
                    >
                      {!isPremium ? (
                        <GradientButton
                          text={translate("sendInGmail")}
                          onClick={handlePremiumRestrictedAction}
                        />
                      ) : (
                        <GradientButton
                          text={translate("sendInGmail")}
                          onClick={openInGmail}
                        />
                      )}

                      {!isPremium && (
                        <div
                          className={`${
                            premiumNoticeBlink
                              ? "premium-notice premium-notice--blink"
                              : "premium-notice"
                          }`}
                          onClick={handleClick2}
                        >
                          {renderPremiumAvailabilityMessage()}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: isCompactActionLayout
                      ? "stretch"
                      : "center",
                  }}
                >
                  <div
                    style={{
                      width: isCompactActionLayout ? "100%" : "auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <GradientButton
                      text={translate("modify")}
                      onClick={handleChangeView}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default GenerateContent;
